<template>
    <modal @close="$emit('close')" ref="modal">
        <template v-slot:title>TCP+ Locations — {{ integration.client.name }}</template>

        <slot>
            <div v-if="loading" class="text-center my-3">
                <i class="far fa-spinner fa-spin"></i> Loading locations from TCP+...
            </div>

            <div v-if="errorMsg" class="alert alert-danger py-2">
                {{ errorMsg }}
            </div>

            <div v-if="!loading && !errorMsg && summary">
                <p class="text-muted">
                    <strong>Total:</strong> {{ summary.total }}
                    &nbsp;·&nbsp;
                    <strong>Active:</strong> {{ summary.active_count }}
                    &nbsp;·&nbsp;
                    <strong>Inactive:</strong> {{ summary.inactive_count }}
                </p>

                <div class="form-row mb-2">
                    <div class="col">
                        <label>
                            <input type="checkbox" v-model="showInactive" />
                            Show inactive
                        </label>
                    </div>
                </div>

                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Name</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Zip</th>
                            <th class="text-center">Active</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in visibleRows" :key="row.id"
                            :class="{'text-muted': !row.active}">
                            <td><small>{{ row.id }}</small></td>
                            <td>{{ row.name }}</td>
                            <td>{{ row.city }}</td>
                            <td>{{ row.state }}</td>
                            <td>{{ row.zip }}</td>
                            <td class="text-center">{{ row.active ? '✓' : '' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Close</button>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-block btn-primary" @click.prevent="fetchSummary()" :disabled="loading">Refresh</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import api from '@/api'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    mixins: [ModalMixin],
    props: ['client', 'integration'],
    data() {
        return {
            loading: false,
            errorMsg: '',
            summary: null,
            showInactive: false,
        }
    },
    computed: {
        visibleRows() {
            if (!this.summary) return []
            return this.showInactive
                ? this.summary.rows
                : this.summary.rows.filter(r => r.active)
        },
    },
    methods: {
        reset() {
            this.summary = null
            this.errorMsg = ''
            this.fetchSummary()
        },
        fetchSummary() {
            this.loading = true
            this.errorMsg = ''
            const url = `/admin/posintegrations/${this.integration.id}/tcpplus/locations`
            api.get(url).then(resp => {
                this.summary = resp
                this.loading = false
            }).catch(errors => {
                this.errorMsg = (errors.__all__ && errors.__all__[0]) || 'Failed to load locations.'
                this.loading = false
            })
        },
    },
}
</script>
